module.exports = "/images/afiliados.jpg?647527e656d041056f8f7a1f907732d0";